import { getEnv } from './getEnv'

/**
 * Derives the customer identifier from the runtime environment label.
 *
 * `window.ENV` is set per deployment (e.g. "CedarsProd", "NorthwellTest", "dev").
 * Stripping known suffixes yields the lowercase customer name used by Unleash
 * context, Langfuse prompt labels, and other customer-scoped logic.
 */
export const getCustomer = (): string =>
  getEnv().replace('Test', '').replace('Prod', '').toLowerCase()
